import React from "react";
import "../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faComment} from "@fortawesome/free-solid-svg-icons";


interface CommentTagProps {
    onClick?: () => void;
}

function CommentTag({ onClick }: CommentTagProps) {
    return (
        <div className={`user-tag d-inline-block`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
            <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faComment}/>
        </div>
    );
}

export default CommentTag;
